/**
 * Sessions API Module
 *
 * API calls for course session (Termin) management
 */

import { apiClient } from './client'
import type {
  CourseSessionDto,
  CreateCourseSessionDto,
  UpdateCourseSessionDto,
} from '@/types/api.types'

export const sessionsApi = {
  /**
   * Get all sessions for a course
   */
  async getByCourse(courseId: number): Promise<CourseSessionDto[]> {
    const response = await apiClient.get<CourseSessionDto[]>(
      `/CourseSessions/by-course/${courseId}`
    )
    return response.data
  },

  /**
   * Get single session by ID
   */
  async getById(id: number): Promise<CourseSessionDto> {
    const response = await apiClient.get<CourseSessionDto>(`/CourseSessions/${id}`)
    return response.data
  },

  /**
   * Create a new session
   */
  async create(data: CreateCourseSessionDto): Promise<CourseSessionDto> {
    const response = await apiClient.post<CourseSessionDto>('/CourseSessions', data)
    return response.data
  },

  /**
   * Update an existing session
   */
  async update(id: number, data: UpdateCourseSessionDto): Promise<void> {
    await apiClient.put(`/CourseSessions/${id}`, data)
  },

  /**
   * Delete a session
   */
  async delete(id: number): Promise<void> {
    await apiClient.delete(`/CourseSessions/${id}`)
  },
}
